import { render, staticRenderFns } from "./Departures.vue?vue&type=template&id=9992b552&"
import script from "./Departures.vue?vue&type=script&lang=js&"
export * from "./Departures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports